import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';

const ItinerarySuggestionActionForm = ({ handleSubmit, onCancel }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Nota">
        <Field
          name="note"
          component={TextInput}
          type="textarea"
          placeholder="Motivo de Anular la Sugerencia (opcional)"
        />
      </FormItem>
    </FormGroup>
    <FormFooter>
      <Button color="secondary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

ItinerarySuggestionActionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'itinerarySuggestionActionForm',
})(ItinerarySuggestionActionForm);
